var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import simpleTable from '../../components/ins-manage/simple-table.vue';
import eventBus from '../../utils/fresh-table';
export default Vue.extend({
    components: {
        simpleTable: simpleTable,
    },
    data: function () {
        var _this = this;
        return {
            channelId: '',
            userEmail: '',
            requestConfig: {
                url: '/proxy/carInsOrder/policy/offline/renewalList',
                method: 'post',
            },
            otherConfig: {
                lazyLoad: true,
            },
            tableConfig: [
                {
                    label: '保单号',
                    prop: 'policyNo',
                    tooltip: true,
                    width: '220px',
                },
                {
                    label: '险种类别',
                    prop: 'policyTypeName',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '保险公司',
                    prop: 'insCompanyName',
                    tooltip: true,
                    width: '140px',
                },
                {
                    label: '投保城市',
                    prop: 'insuranceCityName',
                    width: '100px',
                },
                {
                    label: '车牌号',
                    prop: 'plateNo',
                    width: '120px',
                },
                {
                    label: '投保人',
                    prop: 'applicantName',
                    width: '120px',
                },
                {
                    label: '被保险人',
                    prop: 'insurantName',
                    width: '120px',
                },
                {
                    label: '保险起期',
                    prop: 'insuranceBeginTime',
                    width: '120px',
                },
                {
                    label: '保险止期',
                    prop: 'insuranceEndTime',
                    width: '120px',
                },
                {
                    label: '倒计时',
                    prop: 'remainDaysName',
                    width: '120px',
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    minWidth: '100px',
                    fixed: 'right',
                    btns: [
                        {
                            name: '查看',
                            callback: function (row) {
                                _this.detail(row);
                            },
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        // 获取channelId
        fetchChannelId: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/carInsurance/channel/getInfo',
                                method: 'get',
                                data: {},
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                return res.data;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        // 获取邮箱设置
        getEmail: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/carInsurance/channelBill/getEmails',
                                method: 'get',
                                data: null,
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                if (!res.data || !res.data.emails)
                                    return;
                                _this.userEmail = res.data.emails[0];
                                return res;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        // 续保保单导出
        exportRenewal: function () {
            var _this = this;
            var params = {
                channelId: this.channelId,
            };
            this.$request({
                url: '/proxy/carInsOrder/policy/offline/renewalExport',
                method: 'post',
                data: params,
            }).then(function (res) {
                var failed = !res || res.errorCode;
                if (failed) {
                    _this.$message.error('导出失败');
                }
                else {
                    _this.$message({
                        message: '导出成功',
                        type: 'success',
                    });
                }
            });
        },
        modifyEmail: function () {
            var _this = this;
            this.$prompt('请输入续保提醒邮箱地址，将通过该邮箱定期发送续保提醒邮件。', '提醒邮箱', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: this.userEmail,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                inputValidator: this.validateEmail,
                inputErrorMessage: '邮箱格式不正确',
            })
                .then(function (_a) {
                var value = _a.value;
                _this.setEmail(value).then(function (res) {
                    if (!res)
                        return;
                    if (res.errorCode)
                        return;
                    if (!res.data || !res.data.emails)
                        return;
                    _this.userEmail = res.data.emails[0];
                });
            })
                .catch(function () { });
        },
        validateEmail: function (mail) {
            if (mail === '') {
                return true;
            }
            var regexMail = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
            return regexMail.test(mail);
        },
        // 设置邮箱
        setEmail: function (mail) {
            return __awaiter(this, void 0, void 0, function () {
                var emails, params;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            emails = [mail];
                            params = {
                                emails: emails,
                            };
                            return [4 /*yield*/, this.$request({
                                    url: '/proxy/carInsurance/channelBill/saveEmails',
                                    method: 'post',
                                    data: params,
                                }).then(function (res) {
                                    if (!res)
                                        return;
                                    if (res.errorCode)
                                        return;
                                    return res;
                                })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        detail: function (row) {
            this.$router.push({
                name: 'renewalDetail',
                params: { policyId: row.policyId.toString() },
            });
        },
        loadPage: function () {
            this.requestConfig.params = {
                channelId: this.channelId,
            };
            eventBus.$emit('freshSimpleTable');
            this.getEmail();
        },
        transTableData: function (res, pageInfo) {
            var totalElements = res.data.pageInfo.totalElements;
            var pageSize = pageInfo.pageSize, pageNo = pageInfo.pageNo;
            return {
                pageNo: pageNo,
                pageSize: pageSize,
                totalItemCount: totalElements,
                data: res.data.policyItems,
            };
        },
    },
    mounted: function () {
        var _this = this;
        this.fetchChannelId().then(function (data) {
            _this.channelId = data.channelId;
            _this.loadPage();
        });
    },
});
